/* Show the "Complete the Set" prev/next arrows only when the rail can actually scroll.
   The rail (slider-element) uses native horizontal scroll; when all cards fit (e.g. 2 items
   on desktop) there's nothing meaningful to scroll, so the arrows should be hidden. The
   complementary content is injected async (product-recommendations sets innerHTML), so we
   watch each section with a MutationObserver (timing-proof) + ResizeObserver + window resize. */
(function () {
  function shouldScroll(el) {
    const slider = el.querySelector('slider-element');
    if (!slider || slider.clientWidth === 0) return null; // absent or hidden — don't decide
    const card = el.querySelector('.card-grid > .card');
    const cardW = card ? card.getBoundingClientRect().width : 0;
    const overflow = slider.scrollWidth - slider.clientWidth;
    // Half a card of hidden content = a real next item; a few px is just padding/rounding.
    return cardW > 0 ? overflow > cardW / 2 : overflow > 2;
  }

  function sync(el) {
    const indicators = el.querySelector('.indicators');
    if (!indicators) return;
    const s = shouldScroll(el);
    if (s === null) return;
    indicators.style.display = s ? '' : 'none';
  }

  function attach(el) {
    let raf = 0;
    const run = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; sync(el); });
    };
    const mo = new MutationObserver(function () {
      run();
      const slider = el.querySelector('slider-element');
      if (slider && !slider.__compRO && 'ResizeObserver' in window) {
        slider.__compRO = new ResizeObserver(run);
        slider.__compRO.observe(slider);
      }
    });
    mo.observe(el, { childList: true, subtree: true });
    run();
  }

  function init() {
    document.querySelectorAll('product-recommendations.complementary-products').forEach(attach);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  let rraf = 0;
  window.addEventListener('resize', function () {
    if (rraf) return;
    rraf = requestAnimationFrame(function () {
      rraf = 0;
      document.querySelectorAll('product-recommendations.complementary-products').forEach(sync);
    });
  }, { passive: true });
})();
